import React, { FC } from "react";
import { Box, TablePagination } from "@mui/material";
import styles from "./TableFooter.module.scss";

type tableFooterProps = {
  count: number | undefined;
  page: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  rowsPerPage: number;
  onRowsPerPageChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

const TableFooter: FC<tableFooterProps> = (
  props: tableFooterProps
): JSX.Element => {
  const {
    count = 0,
    page,
    onPageChange,
    rowsPerPage,
    onRowsPerPageChange,
  } = props;
  return (
    <Box
      className={`${styles.tableFooter} pd-x-20 pd-y-20 d-flex align-items-center justify-content-end`}
    >
      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </Box>
  );
};

export default TableFooter;
